import React, {useState, useEffect} from "react";
import Container from "@material-ui/core/Container";
import Title from "../dashboard/Title";
import Button from "@material-ui/core/Button";
import SelectInput from "../form/input/SelectInput";
import UserService from "../../services/user.service";
import {logOut} from "../../helpers/logout";
import {NotificationManager} from 'react-notifications';
import Paper from "@material-ui/core/Paper";
import TextInput from "../form/input/TextInput";
import Popup from "./Popup";
import ActionButton from "../form/input/ActionButton";
import Tooltip from "@material-ui/core/Tooltip";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import ConfirmDialog from "./ConfirmDialog";
import useTable from "./useTable";
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Time from "react-time-format";
import {Redirect} from "react-router-dom";
import {useDashboardStyles, BRAND} from "../settings/dashboardStyles";
import {makeStyles} from "@material-ui/core/styles";

const useLocalStyles = makeStyles(() => ({
    statusDone: {
        display: "inline-flex",
        alignItems: "center",
        padding: "3px 9px",
        background: BRAND.successBg,
        color: BRAND.success,
        borderRadius: 999,
        fontSize: "0.7rem",
        fontWeight: 700,
        letterSpacing: 0.6,
        textTransform: "uppercase",
        border: `1px solid ${BRAND.successBorder}`,
    },
    statusInProgress: {
        display: "inline-flex",
        alignItems: "center",
        padding: "3px 9px",
        background: BRAND.goldBg,
        color: BRAND.deep,
        borderRadius: 999,
        fontSize: "0.7rem",
        fontWeight: 700,
        letterSpacing: 0.6,
        textTransform: "uppercase",
        border: `1px solid ${BRAND.goldSoft}`,
    },
    statusTodo: {
        display: "inline-flex",
        alignItems: "center",
        padding: "3px 9px",
        background: "rgba(90, 102, 117, 0.10)",
        color: BRAND.inkSoft,
        borderRadius: 999,
        fontSize: "0.7rem",
        fontWeight: 700,
        letterSpacing: 0.6,
        textTransform: "uppercase",
        border: "1px solid rgba(90, 102, 117, 0.22)",
    },
    funeralLink: {
        color: BRAND.deep,
        fontWeight: 600,
        cursor: "pointer",
        textDecoration: "underline",
        textUnderlineOffset: 2,
        "&:hover": {
            color: BRAND.deepDark,
        },
    },
    loadMoreRow: {
        marginTop: 12,
        display: "flex",
        justifyContent: "center",
    },
}));

export default function TaskList(props) {
    const classes = useDashboardStyles();
    const localClasses = useLocalStyles();

    const [tasks, setTasks] = useState([]);
    const [templates, setTemplates] = useState([]);
    const [filterFn] = useState({
        fn: items => items
    });
    const [limit, setLimit] = useState(100);
    const [funeralDetail, setFuneralDetail] = useState(null);

    const [values, setValues] = useState({
        _id: null,
        name: '',
        status: 1,
        defaultTask: ''
    });

    const headCells = [
        {id: 'name', label: 'Názov'},
        {id: 'created', label: 'Vytvorené'},
        {id: 'funeral', label: 'Pohreb'},
        {id: 'status', label: 'Stav'},
        {id: 'actions', label: 'Akcie', disableSorting: true, align: 'right'}
    ]

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(tasks, headCells, filterFn);

    const [show, setShow] = useState(false);
    const [confirmDialog, setConfirmDialog] = useState({isOpen: false, title: '', subTitle: ''})

    const handleChange = (event) => {
        const {name, value} = event.target;
        setValues({...values, [name]: value});
    }

    const handleChangeText = (event) => {
        const {name, value} = event.target;
        setValues({...values, name: event.target.value, [name]: value});
    }

    useEffect(() => {
        UserService.getTasks(limit).then(
            (response) => {
                setTasks(response.data);
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                }
            }
        );
        UserService.getGeneralTaskTemplates().then(
            (response) => {
                setTemplates(response.data);
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                }
            }
        );
    }, [limit, props]);

    const resetToDefault = () => {
        setValues({
            _id: null,
            name: '',
            status: 0,
        });
        setShow(false);
    }

    const errNotification = (e) => {
        if (e.response.status === 401) {
            logOut(props);
            NotificationManager.error('Musíte sa nanovo prihlásiť.', 'Chyba', 5000);
        } else {
            NotificationManager.error('Došlo k neočakávanej chybe. Skúste neskôr alebo kontaktujte podporu.', 'Chyba', 5000);
        }
    }

    const handleCreate = (e) => {
        e.preventDefault();

        if (validate()) {
            let data = {
                _id: values._id,
                status: values.status,
                name: values.name
            };

            if (values._id) {
                UserService.updateTask(data).then(
                    () => {
                        UserService.getTasks(limit).then(
                            (response) => {
                                setTasks(response.data);
                                NotificationManager.success('Úloha upravená!', 'Upravené', 5000);
                            },
                            (e) => {
                                if (e.response.status === 401) {
                                    logOut(props);
                                }
                            }
                        );
                        resetToDefault();
                    },
                    (e) => {
                        errNotification(e);
                    }
                );
            } else {
                data.created = new Date();
                UserService.addTask(data).then(
                    () => {
                        UserService.getTasks(limit).then(
                            (response) => {
                                setTasks(response.data);
                                NotificationManager.success('Úloha vytvorená!', 'Vytvorené', 5000);
                            },
                            (e) => {
                                if (e.response.status === 401) {
                                    logOut(props);
                                }
                            }
                        );
                        resetToDefault();
                    },
                    (e) => {
                        errNotification(e);
                    }
                );
            }
        } else {
            NotificationManager.error('Skontrolujte vyplnený formulár!', 'Chyba', 5000);
        }
    };

    const [errors, setErrors] = useState({});

    const validate = () => {
        let temp = {};
        temp.name = values.name !== '' ? "" : "Vyplne názov."
        setErrors({...temp})
        // eslint-disable-next-line eqeqeq
        return Object.values(temp).every(x => x == "")
    }

    const handleDelete = (id) => {
        setConfirmDialog({
            ...confirmDialog,
            isOpen: false
        })
        UserService.deleteTask(id).then(
            () => {
                NotificationManager.success('Úloha vymazaná!', 'Vymazané', 5000);
                UserService.getTasks(limit).then(
                    (response) => {
                        setTasks(response.data);
                    },
                    (e) => {
                        if (e.response.status === 401) {
                            logOut(props);
                            NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                        }
                    }
                );
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                }
                NotificationManager.error('Úlohu sa nepodarilo odstrániť!', 'Chyba', 5000);
            }
        );
    }

    const handleEdit = (vals) => () => {
        setValues(vals);
        setShow(true);
    }

    const getStatusBadge = (val) => {
        switch (val) {
            case 2:
                return <span className={localClasses.statusInProgress}>V procese</span>;
            case 3:
                return <span className={localClasses.statusDone}>Urobené</span>;
            default:
                return <span className={localClasses.statusTodo}>Nerobí sa</span>;
        }
    }

    const handleNoLimit = () => {
        setLimit(0);
    }

    return (
        <Container maxWidth="lg" className={classes.pageContainer}>
            <Paper className={classes.paper} elevation={0}>
                <div className={classes.sectionHeader}>
                    <Title>Zoznam úloh</Title>
                    <div className={classes.sectionToolbar}>
                        <Button
                            startIcon={<AddIcon/>}
                            className={classes.primaryAction}
                            onClick={() => setShow(true)}
                        >
                            Pridať úlohu
                        </Button>
                    </div>
                </div>

                {tasks.length === 0 ? (
                    <div className={classes.emptyState}>
                        Zatiaľ nemáte žiadne úlohy.
                    </div>
                ) : (
                    <>
                        <TblContainer>
                            <TblHead/>
                            <TableBody>
                                {recordsAfterPagingAndSorting().map((item, index) => (
                                    <TableRow key={index}>
                                        <TableCell><strong>{item.name}</strong></TableCell>
                                        <TableCell><Time value={item.created} format="DD.MM.YYYY HH:mm"/></TableCell>
                                        {item.funeral ? (
                                            <TableCell>
                                                <span
                                                    className={localClasses.funeralLink}
                                                    onClick={() => setFuneralDetail(item.funeral._id)}
                                                >
                                                    {item.funeral.deceased}
                                                </span>
                                            </TableCell>
                                        ) : <TableCell>—</TableCell>}
                                        <TableCell>{getStatusBadge(item.status)}</TableCell>
                                        <TableCell align="right">
                                            <ActionButton color="primary">
                                                <Tooltip title="Upraviť úlohu">
                                                    <EditIcon onClick={handleEdit(item)} fontSize="small"/>
                                                </Tooltip>
                                            </ActionButton>
                                            <ActionButton color="secondary">
                                                <Tooltip title="Vymazať úlohu">
                                                    <DeleteIcon
                                                        fontSize="small"
                                                        onClick={() => {
                                                            setConfirmDialog({
                                                                isOpen: true,
                                                                title: 'Naozaj chcete vymazať túto úlohu?',
                                                                subTitle: "Túto operáciu nevieš vrátiť.",
                                                                onConfirm: () => handleDelete(item._id)
                                                            })
                                                        }}
                                                    />
                                                </Tooltip>
                                            </ActionButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </TblContainer>
                        <TblPagination/>
                        <div className={localClasses.loadMoreRow}>
                            <Button size="small" className={classes.secondaryAction} onClick={handleNoLimit}>
                                Načítať viac ako max. 100 záznamov
                            </Button>
                        </div>
                    </>
                )}

                <Popup
                    title={values._id ? 'Úprava úlohy' : 'Pridanie úlohy'}
                    openPopup={show}
                    setOpenPopup={setShow}
                    additionalWork={resetToDefault}
                    maxW="sm"
                    actions={
                        <Button
                            variant="contained"
                            type="submit"
                            form="task-form"
                            className={classes.primaryAction}
                        >
                            {values._id ? "Upraviť úlohu" : "Pridať úlohu"}
                        </Button>
                    }
                >
                    <form id="task-form" autoComplete='off' onSubmit={handleCreate}>
                        <div className={classes.formField}>
                            <TextInput
                                label="Názov"
                                error={errors.name}
                                name={'name'}
                                value={values.name || ''}
                                onChange={handleChange}
                                fullWidth
                            />
                        </div>
                        {!values._id && (
                            <div className={classes.formField}>
                                <SelectInput
                                    label="Preddefinované úlohy"
                                    name={'defaultTask'}
                                    value={values.defaultTask}
                                    options={templates.map((opt) => ({value: opt.name, title: opt.name}))}
                                    onChange={handleChangeText}
                                />
                            </div>
                        )}
                        {values._id && (
                            <div className={classes.formField}>
                                <SelectInput
                                    label="Stav"
                                    name={'status'}
                                    error={errors.status}
                                    value={values.status}
                                    options={[
                                        {value: 1, title: 'Nerobí sa'},
                                        {value: 2, title: 'V procese'},
                                        {value: 3, title: 'Urobené'},
                                    ]}
                                    onChange={handleChange}
                                />
                            </div>
                        )}
                    </form>
                </Popup>
            </Paper>
            <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
                icon={<DeleteIcon/>}
            />
            {funeralDetail ? <Redirect to={{
                pathname: `/pohreb/${funeralDetail}/info`,
                state: {from: props.location}
            }}/> : <></>}
        </Container>
    );
}
